import type { MultiSelectOption } from './MultiSelectFilter';

// A value the address carries that this build has no name for is offered alongside the known
// ones, so it stays tickable and stays visible as the reason the list came back narrow.
export const optionsWithAddressExtras = (
  known: readonly string[],
  inAddress: readonly string[],
  labelOf: (value: string) => string
): MultiSelectOption[] => {
  const extras = inAddress.filter((value) => !known.includes(value));

  return [...known, ...extras].map((value) => ({ value, label: labelOf(value) }));
};
